import React, {useRef, useState} from 'react';
import {Button, Modal, Typography} from "@mui/material";
import Webcam from 'react-webcam';
import {setAttachments} from "@store/chatSlice.tsx";
import {MAX_FILES, MAX_SIZE_MB} from '@config/env';
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";

const CameraCapture = (props: { setFileError: any, setShowCamera: any }) => {
    const webcamRef = useRef(null);
    const [image, setImage] = useState<any>(null);
    const [facingMode, setFacingMode] = useState('environment');
    const dispatch = useDispatch<AppDispatch>();
    const attachments = useSelector((state: any) => state.chat.attachments);

    const capture = () => {
        const screenshot = webcamRef.current.getScreenshot();
        setImage(screenshot);
    };


    const takeAgain = () => {
        setImage(null);
    }


    function base64ToFile(base64String, filename, mimeType) {
        // Remove the "data:..." prefix if present
        const base64Data = base64String.split(',')[1] || base64String;

        // Decode the base64 string
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        // Create a Blob from the decoded data
        const blob = new Blob(byteArrays, {type: mimeType});

        // Create a File object
        const file = new File([blob], filename, {type: mimeType});

        return file;
    }


    const use = () => {
        if (!image) return;
        // Example usage:
        const base64String = image;
        const mimeType = image.split(';')[0].replace('data:', '');
        const filename = "myImage." + mimeType.split('/')[1];

        const files = [base64ToFile(base64String, filename, mimeType)];
        if (!files) return;

        const fileArray = Array.from(files);
        const newTotalFiles = attachments.length + fileArray.length;
        const totalSizeMB =
            [...attachments, ...fileArray].reduce((acc, file) => acc + file.size, 0) /
            (1024 * 1024);
        if (newTotalFiles > MAX_FILES) {
            props.setFileError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }
        if (totalSizeMB > MAX_SIZE_MB) {
            props.setFileError(`Total file size should not exceed ${MAX_SIZE_MB}MB.`);
            return;
        }
        props.setFileError(null);
        dispatch(setAttachments([...attachments, ...fileArray]));
        props.setShowCamera(false);
    }

    const switchCamera = () => {
        setFacingMode(facingMode === 'user' ? 'environment' : 'user');
    }

    return (
        <Modal open={true} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div className={'relative flex flex-col items-center bg-white rounded-lg h-[90vh] w-[90vw] shadow-lg p-4'}>
                {
                    image ? <>
                            <img src={image} alt="Captured" style={{flex: 1}}/>
                            <div className={'flex justify-center items-center gap-5'}>
                                <Button className={'!mt-2'} variant={'contained'} onClick={takeAgain}>Take Again</Button>
                                <Button className={'!mt-2'} variant={'contained'} onClick={use}>Use</Button>
                            </div>
                        </> :
                        <>
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                videoConstraints={{facingMode}}
                                style={{flex: 1}}
                            />
                            <div className={'flex justify-center items-center gap-5'}>
                                <Button className={'!mt-2'} variant={'contained'} onClick={capture}>Capture</Button>
                                <Button className={'!mt-2'} variant={'contained'} onClick={switchCamera}>Switch
                                    Camera</Button>
                            </div>
                        </>
                }
                <Typography
                    className={'text-sm text-white absolute top-2 right-2 cursor-pointer rounded-full px-2 py-1 bg-gray-600'}
                    onClick={() => props.setShowCamera(false)}>
                    X
                </Typography>
            </div>
        </Modal>
    );
};

export default CameraCapture;
